export const SET_LOCKS = 'Lcoks/set';
export const SET_LOCKS_TABKEY = 'Locks/TabKey/set';
export const SET_LOCKS_PAGE = 'Lock/Page/set';

export const SET_LOCKS_UPDATED = 'Lock/UpdateStatus/set';
